//
// Imports
//

import { initialiseSharedComponents } from "../_shared/sharedClient.js";

import * as PjaxClientLib from "../_shared/libs/client/Pjax.client.js";
import * as UserPreferenceClientLib from "../_shared/libs/client/UserPreference.client.js";

//
// Client
//

function initialiseComponents()
{
	initialiseSharedComponents();
}

initialiseComponents();

if (UserPreferenceClientLib.getValue("experimental::lws_pjax"))
{
	PjaxClientLib.initialisePjax(() => initialiseComponents());
}